import { h, Component } from 'preact';
import { observer } from 'mobx-preact';

import PubSub, { topics } from '../../lib/pubsub';

import util from '../../lib/util';

import Top from '../navigation/top';
import { FormRow } from '../form/formField';
import TagTree from './tree';

const initialState = {
    height: 100,
    windowHeight: 0,
};

const FIELDS = {
    id: { label: 'Db #', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    parent: { label: 'Parent tag db #', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    name: { label: 'Tag name', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    alias: { label: 'Alias', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    filter: { label: 'Filter', type: 'radio', values: [{ key: 'Yes', val: 1 }, { key: 'No', val: 0 }], readonly: false, help: 'Field is DealerWeb only.' },
    sort: { label: 'Sort', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    menu: { label: 'Menu', type: 'radio', values: [{ key: 'Yes', val: 1 }, { key: 'No', val: 0 }], readonly: false, help: 'Field is DealerWeb only.' },
    pinned: { label: 'Pinned', type: 'radio', values: [{ key: 'Yes', val: 1 }, { key: 'No', val: 0 }], readonly: false, help: 'Field is DealerWeb only.' },
    field: { label: 'Fields', type: 'json', readonly: false, help: 'Field is DealerWeb only.' },
    create_date: { label: 'Created date', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    updatedDate: { label: 'Updated date', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
};

@observer
class TagEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...initialState,
        };
        this.updateTimer = {};
        const { tagStore } = this.props.stores;
        tagStore.load(props.id);

        this.fields = [
            {
                tabname: 'Basics',
                icon: 'fas fa-user-edit',
                fields: ['id', 'parent', 'name', 'sort', 'alias', 'filter', 'menu', 'pinned', 'field', 'create_date', 'updatedDate'].map(f => util.makeField(f, FIELDS)),
            },
        ];
        this.subscriptions();
    }

    subscriptions() {
        PubSub.subscribe(topics.LEFT_MENU_HEIGHT_UPDATED, (height) => {
            this.setState({ height });
        });
    }

    updateField = async (id, field, value) => {
        const { tagStore } = this.props.stores;
        tagStore.updateField(id, field, value);

        clearTimeout(this.updateTimer[field]);
        this.updateTimer[field] = setTimeout(async () => {
            this.doUpdateField(id, field, value);
        }, 500);
    }

    async doUpdateField(id, field, value) {
        const { tagStore } = this.props.stores;
        await tagStore.saveField(id, field, value);
    }

    render(props) {
        const { height } = this.state;
        const { tagStore } = this.props.stores;
        const { tag, saved } = tagStore;

        let tabIdx = this.fields.findIndex(e => e.tabname === props.tabname);
        if (tabIdx < 0) {
            tabIdx = 0;
        }

        return (
            <div>
                <Top {...props} />

                <div class='row'>
                    <div class='col-2 fixed-top overflow-auto'
                        style={`margin-top: ${height + 60}px; height: calc(100% - ${height + 60}px);`}
                    >
                        <small>
                            <TagTree {...this.props} />
                        </small>
                        <div class='text-center mt-4 mb-2'>
                            <small class='text-muted'>
                                <i class='fas fa-ellipsis-h' />
                            </small>
                        </div>
                    </div>
                    <div class='col-10 offset-2'>
                        <div class='d-flex flex-row bd-highlight mb-3'>
                            <div>
                                <a href='/tags' class={`mr-2 btn btn-sm btn-warning`}>
                                    <i class={`fas fa-arrow-left mr-1`} />
                                    Back
                                </a>
                            </div>
                            <div>
                                <h4>Edit: {tag.id}: {tag.name}</h4>
                            </div>
                        </div>
                        <ul class='nav nav-tabs mb-2'>
                            {this.fields.map(tab => (
                                <li class='nav-item'>
                                    <a class={`nav-link ${props.tabname === tab.tabname ? 'active' : ''}`}
                                        href={`/tags/${props.id}/${tab.tabname}`}
                                    >
                                        <i class={`${tab.icon} mr-2`} />
                                        {tab.tabname}
                                    </a>
                                </li>
                            ))}
                        </ul>

                        {this.fields[tabIdx].fields.map(field => <FormRow
                            field={field}
                            object={tag}
                            saved={saved}
                            updateField={this.updateField}
                        />)}

                    </div>
                </div>
            </div>
        );
    }
}

export default TagEdit;



// WEBPACK FOOTER //
// ./components/tags/edit.js